import { TagCheckIcon } from './TagCheckIcon';

/**
 * author: Michael Irigoyen
 * id A15E3DAA-A545-434C-A876-C141B28A074D
 * name tag-check
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-check.svg
 * tags
 */
export const TagApproveIcon = TagCheckIcon;
export default TagApproveIcon